<template>
  <div v-if="$store.state.metaModule.showQrisManagementMenu">
    <router-view name="dialog"></router-view>
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>
